export default {"src":"/_next/static/media/our-work-circular.0c5b9ed5.svg","height":137,"width":137,"blurWidth":0,"blurHeight":0};